import axios from "axios";
import { BACKEND_URL } from "./config";

export interface ICheckoutPequest {
  quantity: number;
  years: number;
  firstName: string;
  lastName: string;
  country: string;
  state?: string;
  address_1: string;
  address_2?: string;
  zip: string | number;
}

export interface ICheckoutResponse {
  id: string;
  url: string;
}

export const checkout = async (payload:ICheckoutPequest, jwt: string): Promise<ICheckoutResponse> => {
  try {
    const response = await axios.request({
      method: "post",
      url: `${BACKEND_URL}/checkout`,
      data: payload,
      headers: {
        Authorization: "Bearer " + jwt,
      },
    });
    return response.data;
  } catch (err:any) {
    throw err;
  }
};

